<template>
	<div class="flex justify-start w-full mt-3">
		<div class="w-full">
			<div class="w-full">
				<div v-if="task" class="w-full">
					<div class="mb-4 justify-start flex">
						<p>
							{{ $t('enter_date_for') }} <strong>{{ task.name }}</strong>
						</p>
					</div>
					<v-calendar :attributes="dates" @dayclick="onDayClick" is-expanded />
				</div>
				<div class="w-full mt-5">
					<div class="flex flex-col justify-between">
						<div class="mb-4 justify-start flex flex-grow">
							{{ $t('time') }}
						</div>
						<div class="flex ...">
							<div class="flex-grow h-16">
								<BaseSelect v-model="hour" label="" :options="hourOptions" :disable-search="true" :selected-label="null" />
							</div>
							<div class="flex-grow-0 h-16 text-2xl px-1 ">:</div>
							<div class="flex-grow h-16">
								<BaseSelect v-model="minute" label="" :options="minuteOptions" :disable-search="true" :selected-label="null" />
							</div>
						</div>
					</div>
				</div>
				<div class="flex justify-end">
					<BaseButton class="mt-6 btn-blue" @click="saveRepairplanTask">
						{{ $t('general.save') }}
					</BaseButton>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AppsEmployee from '@/mixins/AppsEmployee';
import BaseButton from '@/components/forms/buttons/BaseButton';
import { getMinutesOptions, getHourOptions } from '@/plugins/Utils';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import AppsEmployeeRepository from '@/api/repositories/AppsEmployeeRepository';

export default {
	name: 'AppsEmployeeRepairPlanTasksDetail',
	components: { BaseSelect, BaseButton },
	mixins: [AppsEmployee],
	data() {
		return {
			newTask: '',
			task: null,
			hour: null,
			minute: null,
			date: new Date(),
			hourOptions: getHourOptions(),
			minuteOptions: getMinutesOptions(),
		};
	},
	mounted() {
		this.task = this.getAppsEmployeeDamageCase.repair_shop.repairPlanTasks.find(item => item.id === this.$route.params.taskid);

		const m = this.roundUpTo5Minutes(this.date);
		this.minute = {
			display: m === 0 ? '00' : m.toString(),
			value: m,
		};

		this.hour = {
			display: this.date.getHours().toString(),
			value: this.date.getHours(),
		};
		this.date.setMinutes(this.roundUpTo5Minutes(this.date));
		this.date.setSeconds(0);
		this.date.setMilliseconds(0);
	},
	computed: {
		dates() {
			return [
				{
					highlight: true,
					dates: this.date,
				},
			];
		},
	},
	methods: {
		roundUpTo5Minutes(date) {
			let min = Math.ceil(date.getMinutes() / 5) * 5;
			if (min >= 59) {
				min = 0;
				this.date.setHours(this.date.getHours() + 1);
			}
			return min;
		},
		onDayClick(day) {
			this.date = day.date;
		},
		saveRepairplanTask() {
			const minuteValue = this.minute.value <= 9 ? '0' + this.minute.value : this.minute.value
			const hourValue = this.hour.value <= 9 ? '0' + this.hour.value : this.hour.value
			this.date.setMinutes(minuteValue);
			this.date.setHours(hourValue);

			const time = hourValue + ':' + minuteValue;
			new AppsEmployeeRepository()
				.postRepairPlanStep({ name: this.task.name, date: this.date.getTime() / 1000, time: time })
				.then(response => {
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('work_step_saved').toString(),
						icon: 'success',
					}).then(_ => {
						this.$router.push({ name: 'AppsEmployeeRepairPlanTasks' });
					});
				})
				.catch(error => {});
		},
	},
};
</script>

<style scoped></style>
